import { TokenErrorStatus } from 'module/authentication/types';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { FC } from 'react';
import { TokenError } from '../token-error';
import { LoginWithTokenProps } from './types';
import { useLoginWithToken } from './use-login-with-token';

type Props = LoginWithTokenProps & {
  supportEmail: string;
  loginUrl: string;
};
export const LoginWithToken: FC<React.PropsWithChildren<Props>> = ({
  token,
  tokenType,
  postLogin,
  postOtpTrigger,
  oktaData,
  loginUrl,
  supportEmail,
}) => {
  const [, isError] = useLoginWithToken({
    token,
    tokenType,
    postLogin,
    postOtpTrigger,
    oktaData,
  });

  if (isError) {
    return (
      <TokenError
        loginUrl={loginUrl}
        supportEmail={supportEmail}
        status={TokenErrorStatus.Invalid}
      />
    );
  }

  return <PageLoading />;
};
